import { default as complete_45info3ENHuhRzsEMeta } from "/usr/src/app/pages/new/complete-info.vue?macro=true";
import { default as index5qLIDT4rkiMeta } from "/usr/src/app/pages/new/index.vue?macro=true";
import { default as introptPMqJ8B0qMeta } from "/usr/src/app/pages/new/intro.vue?macro=true";
import { default as _91studentId_93iHOEDdeDYIMeta } from "/usr/src/app/pages/new/meetings/[studentId].vue?macro=true";
import { default as otp_45token4RLPEW0j19Meta } from "/usr/src/app/pages/new/otp-token.vue?macro=true";
import { default as parent_45report2EermAqu61Meta } from "/usr/src/app/pages/new/parent-report.vue?macro=true";
import { default as plansCBmqJJkHA2Meta } from "/usr/src/app/pages/new/plans.vue?macro=true";
import { default as road_45mapUk3TUgmTGyMeta } from "/usr/src/app/pages/new/road-map.vue?macro=true";
import { default as sign_45iniwGw9ESvq2Meta } from "/usr/src/app/pages/new/sign-in.vue?macro=true";
import { default as sign_45up6SJdCP1x09Meta } from "/usr/src/app/pages/new/sign-up.vue?macro=true";
export default [
  {
    name: "new-complete-info",
    path: "/new/complete-info",
    meta: complete_45info3ENHuhRzsEMeta || {},
    component: () => import("/usr/src/app/pages/new/complete-info.vue").then(m => m.default || m)
  },
  {
    name: "new",
    path: "/new",
    component: () => import("/usr/src/app/pages/new/index.vue").then(m => m.default || m)
  },
  {
    name: "new-intro",
    path: "/new/intro",
    meta: introptPMqJ8B0qMeta || {},
    component: () => import("/usr/src/app/pages/new/intro.vue").then(m => m.default || m)
  },
  {
    name: "new-meetings-studentId",
    path: "/new/meetings/:studentId()",
    meta: _91studentId_93iHOEDdeDYIMeta || {},
    component: () => import("/usr/src/app/pages/new/meetings/[studentId].vue").then(m => m.default || m)
  },
  {
    name: "new-otp-token",
    path: "/new/otp-token",
    meta: otp_45token4RLPEW0j19Meta || {},
    component: () => import("/usr/src/app/pages/new/otp-token.vue").then(m => m.default || m)
  },
  {
    name: "new-parent-report",
    path: "/new/parent-report",
    meta: parent_45report2EermAqu61Meta || {},
    component: () => import("/usr/src/app/pages/new/parent-report.vue").then(m => m.default || m)
  },
  {
    name: "new-plans",
    path: "/new/plans",
    meta: plansCBmqJJkHA2Meta || {},
    component: () => import("/usr/src/app/pages/new/plans.vue").then(m => m.default || m)
  },
  {
    name: "new-road-map",
    path: "/new/road-map",
    meta: road_45mapUk3TUgmTGyMeta || {},
    component: () => import("/usr/src/app/pages/new/road-map.vue").then(m => m.default || m)
  },
  {
    name: "new-sign-in",
    path: "/new/sign-in",
    meta: sign_45iniwGw9ESvq2Meta || {},
    component: () => import("/usr/src/app/pages/new/sign-in.vue").then(m => m.default || m)
  },
  {
    name: "new-sign-up",
    path: "/new/sign-up",
    meta: sign_45up6SJdCP1x09Meta || {},
    component: () => import("/usr/src/app/pages/new/sign-up.vue").then(m => m.default || m)
  }
]